import { render, staticRenderFns } from "./ad-immediate-board.vue?vue&type=template&id=09553d5f&scoped=true&"
import script from "./ad-immediate-board.vue?vue&type=script&lang=js&"
export * from "./ad-immediate-board.vue?vue&type=script&lang=js&"
import style0 from "./ad-immediate-board.vue?vue&type=style&index=0&id=09553d5f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09553d5f",
  null
  
)

export default component.exports